import React from 'react';
import { MasterConfig as SiteConfig } from 'shared-types';

interface ThemeEditorProps {
    theme: SiteConfig['theme'];
    onChange: (newTheme: SiteConfig['theme']) => void;
}

const ThemeEditor: React.FC<ThemeEditorProps> = ({ theme, onChange }) => {

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        onChange({ ...theme, [name]: value });
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-200 dark:border-slate-700">
            <div className="flex items-center gap-4">
                <label htmlFor="primaryColor" className="font-medium text-sm text-slate-700 dark:text-slate-300 w-28">Primary Color</label>
                <input
                    type="color"
                    name="primaryColor"
                    id="primaryColor"
                    value={theme.primaryColor || '#000000'}
                    onChange={handleInputChange}
                    className="w-10 h-10 p-1 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md cursor-pointer"
                />
                 <input
                    type="text"
                    name="primaryColor"
                    value={theme.primaryColor || ''}
                    onChange={handleInputChange}
                    className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm"
                    placeholder="#06b6d4"
                />
            </div>
            <div className="flex items-center gap-4">
                <label htmlFor="accentColor" className="font-medium text-sm text-slate-700 dark:text-slate-300 w-28">Accent Color</label>
                 <input
                    type="color"
                    name="accentColor"
                    id="accentColor"
                    value={theme.accentColor || '#000000'}
                    onChange={handleInputChange}
                    className="w-10 h-10 p-1 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md cursor-pointer"
                />
                 <input
                    type="text"
                    name="accentColor"
                    value={theme.accentColor || ''}
                    onChange={handleInputChange}
                    className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm"
                    placeholder="#a855f7"
                />
            </div>
            <div className="md:col-span-2 flex items-center gap-4">
                <label htmlFor="fontFamily" className="font-medium text-sm text-slate-700 dark:text-slate-300 w-28">Font Family</label>
                <input
                    type="text"
                    name="fontFamily"
                    id="fontFamily"
                    value={theme.fontFamily || ''}
                    onChange={handleInputChange}
                    className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm"
                    placeholder="Inter, sans-serif"
                />
            </div>
        </div>
    );
};

export default ThemeEditor;